// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bslogoback[data-v-481139ee]{position:absolute;top:3.2rem;z-index:99}[data-v-481139ee] .vantitempic img{height:100%!important}[data-v-481139ee] .van-image__loading{display:none}", ""]);
// Exports
module.exports = exports;
